const PRECISION = 10;

export { PRECISION };